import styled from 'styled-components';

const Header = styled.div`
  display: flex;
  color: #7a818f;
`;

export default Header;
